<template>
  <!-- Only en for now, not sure we will follow the fr thing -->
  <TextField
    id="mealplan-note"
    :name="`${formNamespace}note.en`"
    :label="t('sites.singleSite.financialConfig.mealPlans.form.additionalInstructions')"
    :placeholder="
      t('sites.singleSite.financialConfig.mealPlans.form.additionalInstructionsPlaceholder')
    "
    :disabled="!editMealPlan"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../routes';
import { inject } from 'vue';

// Set localization
const { t } = useI18n();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

const formNamespace = inject('formNamespace', '');
</script>
